import './App.css';
import React, { useState, useEffect, useRef } from "react";

const knowledgeBase = [
  {
    question: "What is TGPS Infotech?",
    answer:
      "TGPS Infotech is a leading technology company offering comprehensive IT services to businesses across various industries. They focus on innovation, client satisfaction, and strategic technology solutions.",
  },
  {
    question: "What is the vision of TGPS Infotech?",
    answer:
      "The vision of TGPS Infotech is to be the preferred partner for organizations seeking innovative and reliable IT solutions. Read more on our website.",
  },
  {
    question: "What is the mission of TGPS Infotech?",
    answer:
      "TGPS Infotech's mission is to deliver superior IT services that empower businesses to achieve operational excellence and strategic goals. Read more on our website.",
  },
  {
    question: "What IT services does TGPS Infotech offer?",
    answer:
      "TGPS Infotech offers a wide variety of services including Software Development, IT Consulting, Network Infrastructure, Cyber Security, Cloud Computing, and IT Support & Managed Services.",
  },
  {
    question: "What products does TGPS Infotech provide?",
    answer:
      "TGPS Infotech provides products like CRM, ERP, HR Management Services, Operations Management, Financial Management, Job Portals, E-Learning, E-Commerce, and more.",
  },
  {
    question: "What is included in TGPS Infotech's software development services?",
    answer:
      "Software development at TGPS Infotech involves technical expertise and understanding business requirements to create tailored and scalable solutions.",
  },
  {
    question: "What does TGPS Infotech offer in IT consulting?",
    answer:
      "TGPS Infotech offers expert IT consulting to help businesses align their technology strategies with their overall goals.",
  },
  {
    question: "Does TGPS Infotech offer network infrastructure services?",
    answer:
      "Yes, TGPS Infotech designs and implements network infrastructure solutions to ensure secure and scalable connectivity.",
  },
  {
    question: "How does TGPS Infotech ensure cyber security?",
    answer:
      "TGPS Infotech provides proactive cyber security solutions to protect businesses from threats and safeguard critical data.",
  },
  {
    question: "What are the benefits of cloud computing from TGPS Infotech?",
    answer:
      "TGPS Infotech's cloud solutions enhance scalability, flexibility, and cost-efficiency for organizations.",
  },
  {
    question: "What is included in IT support and managed services from TGPS Infotech?",
    answer:
      "TGPS Infotech delivers reliable IT support and managed services to streamline and maintain IT operations.",
  },
  {
    question: "What industries does TGPS Infotech serve?",
    answer:
      "TGPS Infotech serves diverse industries through tailored IT solutions and product offerings like Job Portals, E-Commerce, and Mobile App Development.",
  },
  {
    question: "How can I contact TGPS Infotech?",
    answer:
      "You can contact TGPS Infotech via their website or visit the Contact Us section for more details.",
  },
  {
    question: "What does 'proof of possession' mean in the context of TGPS Infotech?",
    answer:
      "It refers to showcasing blockchain transaction records or transcripts as evidence of responsibility and authenticity in tech solutions.",
  },
];

function App() {
  const [chat, setChat] = useState([
    {
      sender: "bot",
      message:
        "Hello! I'm your TGPS Infotech assistant. Ask me anything about TGPS Infotech.",
    },
  ]);
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat]);

  const findBestAnswer = (userQuestion) => {
    const normalizedInput = userQuestion.trim().toLowerCase();
    let bestMatch = null;
    let bestScore = 0;

    knowledgeBase.forEach(({ question, answer }) => {
      const normalizedQuestion = question.toLowerCase();
      const userWords = normalizedInput.split(/\s+/);
      const questionWords = normalizedQuestion.split(/\s+/);
      let score = 0;
      userWords.forEach((word) => {
        if (questionWords.includes(word)) score++;
      });

      if (score > bestScore) {
        bestScore = score;
        bestMatch = answer;
      }
    });

    if (bestScore === 0) {
      return "Sorry, I couldn't find an answer to that. For more information, please contact us at info@tgpsinfotech.com.";
    }
    return bestMatch;
  };

  const sendMessage = () => {
    if (!input.trim()) return;
    const userMessage = input.trim();
    setChat((prev) => [...prev, { sender: "user", message: userMessage }]);
    setInput("");

    setTimeout(() => {
      const botReply = findBestAnswer(userMessage);
      setChat((prev) => [...prev, { sender: "bot", message: botReply }]);
    }, 800);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  const toggleChatbox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="chat-toggle-button" onClick={toggleChatbox}>
        <img
          src="/logo tgps info.png"
          alt="TGPS Logo"
          className="toggle-logo"
        />
        <span className="notification-badge">1</span>
      </div>

      {isOpen && (
        <div className="chatbox-container">
          <div className="chatbox-header">
            <img
              src="/logo.png"
              alt="TGPS Infotech Logo"
              className="company-logo"
            />
          </div>
          <div className="chatbox-body">
            {chat.map((item, index) => (
              <div key={index} className={`message ${item.sender}`}>
                {item.message}
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>
          <div className="chatbox-footer">
            <input
              type="text"
              placeholder="Ask about TGPS Infotech..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
